<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :width="width"
    append-to-body
    @close="onClose"
  >
    <!-- 图片可能需按需拉取，用最小高度撑住 loading 遮罩 -->
    <div
      v-loading="loading"
      class="image-preview-dialog__body"
    >
      <!-- 多图：受限于弹窗高度纵向滚动，避免张数多时弹窗被撑出屏幕 -->
      <div
        v-if="galleryUrls.length"
        class="image-preview-dialog__gallery"
      >
        <img
          v-for="(url, idx) in galleryUrls"
          :key="idx"
          :src="url"
          class="image-preview-dialog__img"
        >
      </div>
      <img
        v-else-if="imageUrl"
        :src="imageUrl"
        class="image-preview-dialog__img"
      >
    </div>
  </el-dialog>
</template>

<script>
/** 单张/多张图片预览（data URL 或 http URL） */
export default {
  name: 'ImagePreviewDialog',
  props: {
    visible: { type: Boolean, default: false },
    imageUrl: { type: String, default: '' },
    /** 多图预览：非空时优先于 imageUrl，按顺序全部展示 */
    imageUrls: { type: Array, default: () => [] },
    /** 图片尚未就绪时展示遮罩 */
    loading: { type: Boolean, default: false },
    title: { type: String, default: '图片预览' },
    width: { type: String, default: '600px' }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible;
      },
      set (v) {
        this.$emit('update:visible', v);
      }
    },
    galleryUrls () {
      return (this.imageUrls || []).filter(Boolean);
    }
  },
  methods: {
    onClose () {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
.image-preview-dialog__body {
  min-height: 60px;
}

.image-preview-dialog__gallery {
  max-height: 60vh;
  overflow-y: auto;

  .image-preview-dialog__img + .image-preview-dialog__img {
    margin-top: 12px;
  }
}

.image-preview-dialog__img {
  width: 100%;
  max-height: 500px;
  object-fit: contain;
  border-radius: 4px;
  display: block;
}
</style>
